import { type Message as TwilioMessage } from '@twilio/conversations';

import { assertNonNullWithReturn } from '../../utils/assert-non-null';

/** Chat message constructor args. */
export type ChatMessageConstructorArgs = Readonly<{

  /** Twilio message instance. */
  twilioMessage: TwilioMessage;
}>;

/** Chat message. */
export abstract class ChatMessage {
  /** Twilio message instance. */
  protected readonly twilioMessage: TwilioMessage;

  /** ID. */
  public readonly id: string;

  /** Author ID. */
  public readonly authorId: number;

  /** Updated date. */
  public readonly updatedDate: Date | null;

  public constructor(data: ChatMessageConstructorArgs) {
    this.id = data.twilioMessage.sid;
    this.twilioMessage = data.twilioMessage;
    this.updatedDate = data.twilioMessage.dateUpdated;
    this.authorId = Number.parseInt(
      assertNonNullWithReturn(data.twilioMessage.author),
      10,
    );
  }
}
